import { styled } from '@clickcease/cc-client-components-lib'

export const SummaryWidgetWrapper = styled('div', {
  marginTop: '20px',
})

export const SummaryWidgetBody = styled('div', {
  width: '100%',
})

export const SummaryWidgetCardWrapper = styled('div', {
  display: 'flex',
  gap: '20px',
  width: '100%',
})

export const StatBox = styled('div', {
  flex: '1',
  padding: '16px 24px',
  backgroundColor: '$white',
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
})

export const StatTitle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: '14px',
  fontWeight: '600',
  gap: '10px',
})

export const StatTitleRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '$lg',
})

export const StatValue = styled('div', {
  fontSize: '28px',
  fontWeight: '600',
  color: '$buttonBackgroundColor',
  marginBottom: '8px',
  width: '100%',
})

export const StatPercentage = styled('div', {
  fontSize: '14px',
  color: '#666',
})

export const IconCircle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '$appBackground',
})

export const TooltipStyle = {
  width: '16px',
  height: '16px',
}
